var _defs, _g, _g2, _g3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFindItTensile1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 184.45 184.45",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    xlinkHref: "#pattern108182",
    id: "pattern108295",
    patternTransform: "matrix(3.8845 -6.0586 25.28 35.783 3.738 -267.29)"
  }), /*#__PURE__*/React.createElement("pattern", {
    xlinkHref: "#Strips1_1white",
    id: "pattern108182",
    patternTransform: "matrix(4.1515 -4.2382 27.017 25.031 2.876 27.406)"
  }), /*#__PURE__*/React.createElement("pattern", {
    id: "Strips1_1white",
    width: 2,
    height: 1,
    patternTransform: "scale(10)",
    patternUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0-.5h1v2H0z"
  })), /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#3c649b}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd",
    stroke: "#000",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#3c649b",
    strokeWidth: 0.827,
    d: "M-1.106 92.703h197.35v42.48H-1.106z",
    opacity: 0.88,
    transform: "matrix(.93567 0 0 .7307 .931 -4.384)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#pattern108182)",
    strokeWidth: 0.825,
    d: "M-1.106 92.865h197.35v42.317H-1.106z",
    transform: "matrix(.93567 0 0 .7307 .931 -4.384)"
  }), /*#__PURE__*/React.createElement("g", {
    strokeWidth: 0.954
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#3c649b",
    d: "M.012-173.72h184.66v60.493H.012z",
    opacity: 0.88,
    transform: "matrix(1 0 0 -.51311 -.116 36.298)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#pattern108295)",
    d: "M.012-173.72h184.66v60.493H.012z",
    transform: "matrix(1 0 0 -.51311 -.116 36.298)"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    strokeWidth: 0.911
  }, /*#__PURE__*/React.createElement("path", {
    d: "M76.695 33.66h31.1a27 22.422 0 0 1 27 22.422 8.88 7.374 0 0 1-8.88 7.374h-67.38a8.88 7.374 0 0 1-8.88-7.374 27 22.422 0 0 1 27.04-22.422z",
    className: "cls-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m105.78 137.83-12.14 12.365a1.82 1.511 0 0 1-2.83 0L78.7 137.83a6.08 5.05 0 0 1-1.36-3.164V62.051h29.8v72.615a6.08 5.05 0 0 1-1.36 3.164z",
    className: "cls-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m107.12 76.926-29.77 2.491-2.13-1.827a1 .83 0 0 1 0-1.17l2.13-1.828 29.77-2.49 2.13 1.826a1 .83 0 0 1 0 1.18zM107.12 81.76l-29.77 2.491-2.13-1.827a1 .83 0 0 1 0-1.17l2.13-1.828 29.77-2.49 2.13 1.826a1 .83 0 0 1 0 1.18z",
    className: "cls-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m107.12 86.584-29.77 2.491-2.13-1.818a1 .83 0 0 1 0-1.18l2.13-1.826 29.77-2.492 2.13 1.819a1 .83 0 0 1 0 1.179z",
    className: "cls-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.12 91.409 77.35 93.9l-2.13-1.818a1 .83 0 0 1 0-1.18l2.13-1.826 29.77-2.492 2.13 1.819a1 .83 0 0 1 0 1.179z",
    className: "cls-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m107.12 96.234-29.77 2.491-2.13-1.827a1 .83 0 0 1 0-1.179l2.13-1.827 29.77-2.491 2.13 1.827a1 .83 0 0 1 0 1.17zM107.12 101.06l-29.77 2.491-2.13-1.827a1 .83 0 0 1 0-1.179l2.13-1.818 29.77-2.492 2.13 1.827a1 .83 0 0 1 0 1.171z",
    className: "cls-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m107.12 105.88-29.77 2.491-2.13-1.827a1 .83 0 0 1 0-1.17l2.13-1.828 29.77-2.49 2.13 1.826a1 .83 0 0 1 0 1.18zM107.12 110.71l-29.77 2.491-2.13-1.785a1 .83 0 0 1 0-1.171l2.13-1.827 29.77-2.491 2.13 1.827a1 .83 0 0 1 0 1.179zM107.12 115.57l-29.77 2.491-2.13-1.827a1 .83 0 0 1 0-1.17l2.13-1.828 29.77-2.49 2.13 1.826a1 .83 0 0 1 0 1.18z",
    className: "cls-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m107.12 120.37-29.77 2.491-2.13-1.818a1 .83 0 0 1 0-1.18l2.13-1.826 29.77-2.492 2.13 1.819a1 .83 0 0 1 0 1.179z",
    className: "cls-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m107.12 125.19-29.77 2.491-2.13-1.818a1 .83 0 0 1 0-1.18l2.13-1.827 29.77-2.49 2.13 1.818a1 .83 0 0 1 0 1.179z",
    className: "cls-1"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    fill: "#3c649b"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m56.13 125.358-2.946 2.404v20.722l2.826 2.306h37.2l.029-25.452z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m128.323 150.77 2.946-2.404v-20.722l-2.827-2.306H91.243l-.029 25.452z"
  }))), /*#__PURE__*/React.createElement("g", {
    fill: "#3c649b",
    stroke: "#3c649b"
  }, /*#__PURE__*/React.createElement("path", {
    strokeMiterlimit: 0,
    strokeWidth: 0.807,
    d: "m149.72 72.312-33.365.262.005 12.655 33.365-.262z",
    color: "#000",
    style: {
      InkscapeStroke: "none"
    },
    transform: "rotate(90 124.53 113.4)"
  }), /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    strokeWidth: 5.197,
    d: "m51.013 45.3 90.909 33.241-90.787 33.573c14.478-19.75 14.345-46.735-.122-66.814z",
    color: "#000",
    style: {
      InkscapeStroke: "none"
    },
    transform: "rotate(90 36.852 151.112) scale(.36515)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.906 42.859a2.599 2.599 0 0 0-3.002 3.959c13.826 19.189 13.941 44.926.135 63.76a2.599 2.599 0 0 0 2.998 3.973l90.787-33.572a2.599 2.599 0 0 0-.01-4.88zm5.162 7.422 77.326 28.273-77.12 28.518c9.615-17.616 9.484-39.005-.206-56.791z",
    color: "#000",
    style: {
      InkscapeStroke: "none"
    },
    transform: "rotate(90 36.852 151.112) scale(.36515)"
  }))), /*#__PURE__*/React.createElement("g", {
    fill: "#3c649b",
    stroke: "#3c649b"
  }, /*#__PURE__*/React.createElement("path", {
    strokeMiterlimit: 0,
    strokeWidth: 0.807,
    d: "m149.72 72.312-33.365.262.005 12.655 33.365-.262z",
    color: "#000",
    style: {
      InkscapeStroke: "none"
    },
    transform: "rotate(90 57.533 46.398)"
  }), /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    strokeWidth: 5.197,
    d: "m51.013 45.3 90.909 33.241-90.787 33.573c14.478-19.75 14.345-46.735-.122-66.814z",
    color: "#000",
    style: {
      InkscapeStroke: "none"
    },
    transform: "rotate(90 -30.146 84.11) scale(.36515)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.906 42.859a2.599 2.599 0 0 0-3.002 3.959c13.826 19.189 13.941 44.926.135 63.76a2.599 2.599 0 0 0 2.998 3.973l90.787-33.572a2.599 2.599 0 0 0-.01-4.88zm5.162 7.422 77.326 28.273-77.12 28.518c9.615-17.616 9.484-39.005-.206-56.791z",
    color: "#000",
    style: {
      InkscapeStroke: "none"
    },
    transform: "rotate(90 -30.146 84.11) scale(.36515)"
  }))), /*#__PURE__*/React.createElement("g", {
    fill: "#3c649b",
    stroke: "#3c649b"
  }, /*#__PURE__*/React.createElement("path", {
    strokeMiterlimit: 0,
    strokeWidth: 0.807,
    d: "m149.72 72.312-33.365.262.005 12.655 33.365-.262z",
    color: "#000",
    style: {
      InkscapeStroke: "none"
    },
    transform: "matrix(0 -1 -1 0 237.93 199.59)"
  }), /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    strokeWidth: 5.197,
    d: "m51.013 45.3 90.909 33.241-90.787 33.573c14.478-19.75 14.345-46.735-.122-66.814z",
    color: "#000",
    style: {
      InkscapeStroke: "none"
    },
    transform: "matrix(0 -.36515 -.36515 0 187.963 74.2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.906 42.859a2.599 2.599 0 0 0-3.002 3.959c13.826 19.189 13.941 44.926.135 63.76a2.599 2.599 0 0 0 2.998 3.973l90.787-33.572a2.599 2.599 0 0 0-.01-4.88zm5.162 7.422 77.326 28.273-77.12 28.518c9.615-17.616 9.484-39.005-.206-56.791z",
    color: "#000",
    style: {
      InkscapeStroke: "none"
    },
    transform: "matrix(0 -.36515 -.36515 0 187.963 74.2)"
  }))), /*#__PURE__*/React.createElement("g", {
    fill: "#3c649b",
    stroke: "#3c649b"
  }, /*#__PURE__*/React.createElement("path", {
    strokeMiterlimit: 0,
    strokeWidth: 0.807,
    d: "m149.72 72.312-33.365.262.005 12.655 33.365-.262z",
    color: "#000",
    style: {
      InkscapeStroke: "none"
    },
    transform: "matrix(0 -1 -1 0 103.93 199.59)"
  }), /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    strokeWidth: 5.197,
    d: "m51.013 45.3 90.909 33.241-90.787 33.573c14.478-19.75 14.345-46.735-.122-66.814z",
    color: "#000",
    style: {
      InkscapeStroke: "none"
    },
    transform: "matrix(0 -.36515 -.36515 0 53.963 74.2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.906 42.859a2.599 2.599 0 0 0-3.002 3.959c13.826 19.189 13.941 44.926.135 63.76a2.599 2.599 0 0 0 2.998 3.973l90.787-33.572a2.599 2.599 0 0 0-.01-4.88zm5.162 7.422 77.326 28.273-77.12 28.518c9.615-17.616 9.484-39.005-.206-56.791z",
    color: "#000",
    style: {
      InkscapeStroke: "none"
    },
    transform: "matrix(0 -.36515 -.36515 0 53.963 74.2)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFindItTensile1);
export default __webpack_public_path__ + "static/media/FindIt_tensile-1.ec9c5d244bb15e3db67108e3850e1106.svg";
export { ForwardRef as ReactComponent };